import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-update-array-buttons',
  templateUrl: './update-array-buttons.component.html',
  styleUrls: ['./update-array-buttons.component.scss']
})
export class UpdateArrayButtonsComponent implements OnInit {

  @Input() enableRemove: boolean;
  @Input() enableAdd: boolean;
  @Output() updateArray = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  public updateArrayClicked(add: boolean): void {
    this.updateArray.emit(add);
  }
}
